import {CSSProperties, FC, MouseEvent} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {NuklieResource} from '../../../services/nuklieService'
import {useNuklie} from './NuklieProvider'
import {NUKLIE_ICON} from './constants'
import styles from './nuklie.module.css'

type Props = {
  resource: NuklieResource
  id?: string | null
  className?: string
  style?: CSSProperties
}

/**
 * Ícone que abre a conversa do cliente no Atendimento Nuklie. Para usina, proposta, OS e
 * solicitação, o backend resolve o cliente vinculado. Não aparece sem a integração ativa.
 */
export const NuklieConversationButton: FC<Props> = ({resource, id, className, style}) => {
  const {enabled, openConversation} = useNuklie()

  if (!enabled || !id) return null

  const handleClick = (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    openConversation(resource, id)
  }

  return (
    <OverlayTrigger
      placement='top'
      overlay={<Tooltip id={`nuklie-${resource}-${id}`}>Abrir conversa no Atendimento Nuklie</Tooltip>}
    >
      <button
        type='button'
        className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm ${className || ''}`}
        style={style}
        onClick={handleClick}
        aria-label='Abrir conversa no Atendimento Nuklie'
      >
        <img src={NUKLIE_ICON} alt='' className={styles.buttonIcon} />
      </button>
    </OverlayTrigger>
  )
}
